// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XN3L4","input":"styles_input__13lPv"};